import React from "react"
import Navigation from "./Navigation"
import Footer from "./Footer"
import QuoteModal from "./QuoteModal"
import PageJumpBar from "./PageJumpBar"

interface LayoutProps {
  children: React.ReactNode
  /** the BROWSE tab and floating GET FREE QUOTE button of the other pages */
  jumpBar?: boolean
}

const Layout = ({ children, jumpBar = false }: LayoutProps) => {
  const [showQuoteModal, setShowQuoteModal] = React.useState(false)

  return (
    <div className="min-h-screen font-poppins">
      <Navigation onQuoteClick={() => setShowQuoteModal(true)} />
      <main>{children}</main>
      {jumpBar && <PageJumpBar onQuote={() => setShowQuoteModal(true)} />}
      <Footer />
      <QuoteModal 
        open={showQuoteModal}
        onOpenChange={setShowQuoteModal}
      />
    </div>
  )
}

export default Layout

